import React from 'react';

import { Redirect, useLocation } from 'react-router-dom';
import Helmet from "react-helmet";
import { useTranslation } from 'react-i18next';
import ScrollToTop from './common/ScrollToTop';
import { useTemporaryReservation } from './ad/OtherServices/AirportTransferTaxi/TemporaryReservation/useTemporaryReservation';
import LoadingModal from './ad/OtherServices/AirportTransferTaxi/common/LoadingModal';
import AirportTransferTaxi from './ad/OtherServices/AirportTransferTaxi/Reservation';
import { convertStringToTaxiCompany } from '../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { isTabiCube } from './ad/OtherServices/AirportTransferTaxi/common/TabiCube';
import AirportTransferTaxiHeader from './ad/OtherServices/AirportTransferTaxi/common/Header';
import AirportTransferTaxiFooter from './ad/OtherServices/AirportTransferTaxi/common/Footer';
import { HelmetProvider } from 'react-helmet-async';
import AdobeAnalyticsScript from './ad/Common/AdobeAnalyticsScript';

export const Booking: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const {
    code,
    token,
    isLoadingReservation,
    hasReservation,
    tmpReservation,
    taxiCompanyConf,
    isDebug
  } = useTemporaryReservation();

  /** 仮予約情報の会社コード。 */
  const companyCode = tmpReservation?.companyCode;
  const company = convertStringToTaxiCompany(companyCode || '')

  const targetTaxiComf = (()=>{
    if(company && taxiCompanyConf) {
      return taxiCompanyConf[company];
    }
  })()

  /** 仮予約情報に含まれたreferrerパラメーターの値。 */
  const referrer = tmpReservation?.referrer;
  /** 旅CUBEモードであるかを表すフラグ。 */
  const tabiCube = isTabiCube(referrer || '');
  /** ページタイトル。 */
  const title = tabiCube ? t('tabicube') : t('title');

  return (
    <div>
      <HelmetProvider>
        <Helmet>
          {/* ページタイトルを設定する。 */}
          <title>{title}</title>
          {/* Adobe Analyticsでタクシー予約画面のアクセス数の集計をする。 */}
          {/* <script type="application/javascript">
            s.pageName=location.origin+&quot;/booking&quot;;
            s.t();
          </script> */}
        </Helmet>
      </HelmetProvider>
      <AdobeAnalyticsScript path="/booking"/>
      {/* 読込中は読込中アイコンを表示する。 */}
      <LoadingModal isLoading={isLoadingReservation}/>
      {/* タクシーの仮予約情報が参照できた場合。 */}
      { (hasReservation && tmpReservation && targetTaxiComf) &&
        <>
          {/* 画面遷移時に画面トップへ遷移させるためのコンポーネント。 */}
          <ScrollToTop />
          {/* ヘッダー部分 */}
          <AirportTransferTaxiHeader tabiCube={tabiCube} />
          {/* タクシー会社が存在するの場合。 */}
          { company !== null &&
            <AirportTransferTaxi
              code={code}
              token={token}
              reservation={tmpReservation}
              // TODO: Reduxから取得するようにしたい
              taxiCompanyConf={targetTaxiComf}
              taxiCompany={company}
              isDebug={isDebug}
            />
          }
          {/* フッター部分 */}
          <AirportTransferTaxiFooter tabiCube={tabiCube} />
        </>
      }
      {/* APIへリクエストしていない状態で、予約情報が取得できなかった場合は404ページにリダイレクトする。 */}
      { (!isLoadingReservation && !hasReservation) &&
          <Redirect to={{ pathname: '/404', state: {redirectOrigin: location.pathname} }} />
      }
    </div>
  );
}

export default Booking;
